import React, { useEffect } from "react";
import { getAdminPortalUrl, isLocalDevHost } from "../utils/adminHost";

/** Main site /admin — send everyone to the dedicated admin host. */
export default function AdminPortalRedirect() {
  useEffect(() => {
    if (isLocalDevHost()) {
      const { origin } = window.location;
      window.location.replace(`${origin}/login`);
      return;
    }
    window.location.replace(getAdminPortalUrl("/admin"));
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: "#0A0F18" }}
    >
      <p className="text-white/70 text-sm text-center">
        Opening the admin portal…
      </p>
    </div>
  );
}
